import PermissionGate from "../../layout/PermissionGate";

const Online = ({ openPopup, busy, id }) => {
  switch (busy) {
    case true:
      return (
        <PermissionGate required={`mark_driver_free`} fallback={<></>}>
          <span
            onClick={() => {
              openPopup("change-availability", {
                id: id,
                busy: busy,
              });
            }}
            className="btn px-3 btn-outline btn-warning btn-color-white btn-sm"
            title="Mark Driver Free"
          >
            <i className="bi-duotone bi-pause-circle fs-5"></i>
          </span>
        </PermissionGate>
      );
    case false:
      return (
        <PermissionGate required={`mark_driver_busy`} fallback={<></>}>
          <span
            onClick={() => {
              openPopup("change-availability", {
                id: id,
                busy: busy,
              });
            }}
            className="btn px-3 btn-outline btn-success btn-color-white btn-sm"
            title="Mark Driver Busy"
          >
            <i className="bi-duotone bi-play-circle fs-5"></i>
          </span>
        </PermissionGate>
      );
    default:
      return <span></span>;
  }
};

export default Online;
